import { immerable } from "immer";
import { ReservationTag } from "./reservation-tag";

export class Customer {
    [immerable] = true;
    
    customerId?: string | null;
    name?: string;
    surname?: string;
    mail?: string;
    telephone?: string;
    address?: string;
    country?: string;
    creationTime?: number;
    customerType?: string;
    before_last_visit?: number;
    last_visit?: number;
    cancelled_counter?: number;
    reservations_counter?: number;
    notshown_counter?: number;
    notes?: string;
    smokingArea?: boolean;
    allergy?: string = '';
    customerTags?: ReservationTag[];
}

export class CustomerExtended extends Customer {
    roomNumber?: string;
    roomBookingId?: string;
    boardType?: string;
    numberOfAdults?: string;
    numberOfChildren?: string;
    arrivalDate?: string;
    departureDate?: string;
    metadata?: PmsInfo;
}

export interface PmsInfoEntry {
  captionGreek?: string;
  captionEnglish?: string;
  key?: string;
  value?: string;
}

export interface PmsInfo {
  dataType?: string;
  values: PmsInfoEntry[];
}

export class CustomerType {
    value: string = '';
    order: string = '';
    description_en: string = '';
    description_el: string = '';
    description_hr?: string = '';
    description_sr?: string = '';
    ireserve?: boolean;
    color: string = '';

    description: string = '';
}
